import {Component} from '@angular/core';
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {TranslateService} from "../../translate/translate.service";
import {HelperService} from "../../lib/helper.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AccessorService} from "./accessor.service";
import { Site } from "../../models/support.model";

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<div class="row">
				<div class="col-md-4">
					<input class="form-control" [(ngModel)]="siteUrl" [ngModelOptions]="{standalone: true}">
					<br>
					<button type="button" class="btn btn-success" (click)="apply()">{{ 'adminstat.common.Apply' | translate }}</button>
				</div>
			</div>

			<br><br><hr>
			
			<loading [isLoad]="loader"></loading>
			
			<div class="row" *ngIf="siteInfo && siteInfo.domainUrl">
				<div class="col-md-3">
					<b>{{ 'adminstat.common.Site' | translate }}:</b>
					<site_info [siteUrl]="siteInfo.domainUrl"></site_info>
				</div>

				<div class="col-md-3">
					<b>{{ 'adminstat.support.accessor.currentCategory' | translate }}:</b> {{ siteInfo.realCategoryId }} - {{ siteInfo.realSubjectId }}
				</div>

				<div class="col-md-3">
					<b>{{ 'adminstat.support.accessor.isBlock' | translate }}:</b> {{ siteInfo.isBlock == 0 ? ('adminstat.filterForm.no' | translate) : ('adminstat.filterForm.yes'  | translate) }}<br>
					<b>{{ 'adminstat.support.accessor.isBan' | translate }}:</b> {{ siteInfo.isBan == 0 ? ('adminstat.filterForm.no' | translate) : ('adminstat.filterForm.yes'  | translate) }}<br>
					<b>{{ 'adminstat.support.accessor.isRemoved' | translate }}:</b> {{ siteInfo.removed == 0 ? ('adminstat.filterForm.no' | translate) : ('adminstat.filterForm.yes'  | translate) }}
				</div>

				<div class="col-md-3">
					<b>{{ 'adminstat.common.Status' | translate }}:</b> {{ siteInfo.paidType }}
				</div>
			</div>
			
			<br>
			
			<div class="row">
				<table class="table" *ngIf="stats && stats.length > 0">
					<thead>
					 	<th>{{ 'adminstat.common.Date' | translate }}</th>
						<th>{{ 'adminstat.support.accessor.accessor' | translate }}</th>
						<th>{{ 'adminstat.support.accessor.Category' | translate }}</th>
					</thead>
					
					<tbody>
						<tr *ngFor="let stat of stats">
							<td>
								{{ stat.time }}
							</td>
							
							<td>
								{{ stat.accessor }}
							</td>
							
							<td>
								<ng-container *ngIf="stat.mark == 'accessor | defer site'">
									{{ 'adminstat.support.accessor.site is defered' | translate }}
								</ng-container>
								
								<ng-container *ngIf="stat.mark == 'accessor | edit site' || stat.mark == 'accessor | top site'">
									{{ stat.category }} - {{ stat.subject }}
								</ng-container>

								<i class="fa fa-star" aria-hidden="true" *ngIf="stat.mark == 'accessor | top site'"></i>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</info-modal>
	`
})
export class AccessorSiteStatsModalComponent extends InfoModalComponent {
	siteUrl: string;
	stats: object[] = [];
	loader: boolean = false;
	siteInfo: Site;
	
	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		public translate: TranslateService,
		public service: AccessorService
	) {
		super(activeModal);
	}

	ok() {
		this.close();
	}
	
	async apply() {
		this.loader = true;
		
		const { stats, siteInfo, } = await this.service.getSiteDetails({
			url: this.siteUrl
		}).toPromise();
		this.stats    = stats;
		this.siteInfo = siteInfo;
		
		this.loader = false;
	}
}
